var React = require('react');

function Calendar (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.3929 2.57145H11.7857V0.830375C11.7857 0.609392 11.6049 0.428589 11.3839 0.428589H10.0446C9.82366 0.428589 9.64286 0.609392 9.64286 0.830375V2.57145H5.35714V0.830375C5.35714 0.609392 5.17634 0.428589 4.95536 0.428589H3.61607C3.39509 0.428589 3.21429 0.609392 3.21429 0.830375V2.57145H1.60714C0.719866 2.57145 0 3.29131 0 4.17859V15.9643C0 16.8516 0.719866 17.5714 1.60714 17.5714H13.3929C14.2801 17.5714 15 16.8516 15 15.9643V4.17859C15 3.29131 14.2801 2.57145 13.3929 2.57145ZM13.192 15.9643H1.80804C1.69754 15.9643 1.60714 15.8739 1.60714 15.7634V5.78573H13.3929V15.7634C13.3929 15.8739 13.3025 15.9643 13.192 15.9643Z","fill":"currentColor"}));
}

Calendar.defaultProps = {"width":"15","height":"18","viewBox":"0 0 15 18","fill":"none"};

module.exports = Calendar;

Calendar.default = Calendar;
